/**
 * @generated SignedSource<<ff9512222bc6e413c068475743d12af7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime'
import { FragmentRefs } from 'relay-runtime'
export type PaginationInput = {
  from?: number | null
  size?: number | null
}
export type postPage_indexQuery$variables = {
  slug: string
  page: PaginationInput
  shortCodeCemeteryIds: ReadonlyArray<number>
  requestShortCodeCemeteryIdSize: number
  shortCodeSlugs: ReadonlyArray<string>
  requestShortCodeSlugSize: number
  parentSlug?: ReadonlyArray<string | null> | null
}
export type postPage_indexQuery$data = {
  readonly post: {
    readonly child_posts: {
      readonly ' $fragmentSpreads': FragmentRefs<'PostList_posts'>
    }
    readonly parent_post: {
      readonly short_title: string | null
    } | null
    readonly template_name: string
    readonly status: string
    readonly redirect_to: string | null
    readonly ' $fragmentSpreads': FragmentRefs<
      | 'Post_post'
      | 'PostList_post'
      | 'PostStructuredData_post'
      | 'PostSeoHead_post'
      | 'Breadcrumb_post'
      | 'RelatedPosts_post'
      | 'PostNoTitle_post'
    >
  } | null
  readonly shortCodeCemeteries: {
    readonly ' $fragmentSpreads': FragmentRefs<'ShortCodeContextProvider_cemeteryFragment'>
  }
  readonly shortCodePosts: {
    readonly ' $fragmentSpreads': FragmentRefs<'ShortCodeContextProvider_postFragment'>
  }
  readonly newlyPosts: {
    readonly ' $fragmentSpreads': FragmentRefs<'PostListCard_posts'>
  }
  readonly newlyCemeteryPosts: {
    readonly ' $fragmentSpreads': FragmentRefs<'PostListCard_posts'>
  }
  readonly sameParentPosts: {
    readonly ' $fragmentSpreads': FragmentRefs<'SameParentPostList_Fragment'>
  }
}
export type postPage_indexQuery = {
  variables: postPage_indexQuery$variables
  response: postPage_indexQuery$data
}

const node: ConcreteRequest = (function () {
  var v0 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'page'
    },
    v1 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'parentSlug'
    },
    v2 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'requestShortCodeCemeteryIdSize'
    },
    v3 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'requestShortCodeSlugSize'
    },
    v4 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'shortCodeCemeteryIds'
    },
    v5 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'shortCodeSlugs'
    },
    v6 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'slug'
    },
    v7 = [
      {
        kind: 'Variable',
        name: 'slug',
        variableName: 'slug'
      }
    ],
    v8 = [
      {
        kind: 'Variable',
        name: 'page',
        variableName: 'page'
      }
    ],
    v9 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'short_title',
      storageKey: null
    },
    v10 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'template_name',
      storageKey: null
    },
    v11 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'status',
      storageKey: null
    },
    v12 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'redirect_to',
      storageKey: null
    },
    v13 = {
      kind: 'Literal',
      name: 'from',
      value: 0
    },
    v14 = [
      {
        fields: [
          {
            kind: 'Variable',
            name: 'ids',
            variableName: 'shortCodeCemeteryIds'
          }
        ],
        kind: 'ObjectValue',
        name: 'filter'
      },
      {
        fields: [
          v13 /*: any*/,
          {
            kind: 'Variable',
            name: 'size',
            variableName: 'requestShortCodeCemeteryIdSize'
          }
        ],
        kind: 'ObjectValue',
        name: 'page'
      }
    ],
    v15 = [
      {
        fields: [
          {
            kind: 'Variable',
            name: 'slugs',
            variableName: 'shortCodeSlugs'
          }
        ],
        kind: 'ObjectValue',
        name: 'filter'
      },
      {
        fields: [
          v13 /*: any*/,
          {
            kind: 'Variable',
            name: 'size',
            variableName: 'requestShortCodeSlugSize'
          }
        ],
        kind: 'ObjectValue',
        name: 'page'
      }
    ],
    v16 = {
      kind: 'Literal',
      name: 'page',
      value: {
        from: 0,
        size: 5
      }
    },
    v17 = [
      {
        kind: 'Literal',
        name: 'filter',
        value: {
          template_name: 'show_post'
        }
      },
      v16 /*: any*/
    ],
    v18 = [
      {
        args: null,
        kind: 'FragmentSpread',
        name: 'PostListCard_posts'
      }
    ],
    v19 = [
      {
        kind: 'Literal',
        name: 'filter',
        value: {
          parent_slugs: ['ohaka']
        }
      },
      v16 /*: any*/
    ],
    v20 = [
      {
        fields: [
          {
            kind: 'Variable',
            name: 'parent_slugs',
            variableName: 'parentSlug'
          }
        ],
        kind: 'ObjectValue',
        name: 'filter'
      },
      {
        kind: 'Literal',
        name: 'page',
        value: {
          size: 8
        }
      }
    ],
    v21 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'slug',
      storageKey: null
    },
    v22 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'h1',
      storageKey: null
    },
    v23 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'url',
      storageKey: null
    },
    v24 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'alt',
      storageKey: null
    },
    v25 = {
      alias: null,
      args: null,
      concreteType: 'PostImage',
      kind: 'LinkedField',
      name: 'image',
      plural: false,
      selections: [v23 /*: any*/, v24 /*: any*/],
      storageKey: null
    },
    v26 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'modified_at',
      storageKey: null
    },
    v27 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'code',
      storageKey: null
    },
    v28 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'meta_description',
      storageKey: null
    },
    v29 = {
      alias: 'cemeteryId',
      args: null,
      kind: 'ScalarField',
      name: 'id',
      storageKey: null
    },
    v30 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'name',
      storageKey: null
    },
    v31 = {
      alias: 'cityId',
      args: null,
      kind: 'ScalarField',
      name: 'id',
      storageKey: null
    },
    v32 = {
      alias: null,
      args: null,
      concreteType: 'CitySimple',
      kind: 'LinkedField',
      name: 'designatedCity',
      plural: false,
      selections: [
        {
          alias: 'designatedCityId',
          args: null,
          kind: 'ScalarField',
          name: 'id',
          storageKey: null
        },
        v30 /*: any*/
      ],
      storageKey: null
    },
    v33 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'count',
      storageKey: null
    },
    v34 = [
      v31 /*: any*/,
      v30 /*: any*/,
      v32 /*: any*/,
      {
        alias: null,
        args: null,
        concreteType: 'CemeteryCount',
        kind: 'LinkedField',
        name: 'cemeteryCount',
        plural: false,
        selections: [v33 /*: any*/],
        storageKey: null
      }
    ],
    v35 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'roma',
      storageKey: null
    },
    v36 = [v24 /*: any*/, v23 /*: any*/],
    v37 = {
      alias: null,
      args: null,
      concreteType: 'PostImage',
      kind: 'LinkedField',
      name: 'image',
      plural: false,
      selections: v36 /*: any*/,
      storageKey: null
    },
    v38 = [v30 /*: any*/, v27 /*: any*/],
    v39 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'path',
      storageKey: null
    },
    v40 = [v27 /*: any*/, v30 /*: any*/],
    v41 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'category_code',
      storageKey: null
    },
    v42 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'price1',
      storageKey: null
    },
    v43 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'price1_unit',
      storageKey: null
    },
    v44 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'price2',
      storageKey: null
    },
    v45 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'price2_unit',
      storageKey: null
    },
    v46 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'purchase_price',
      storageKey: null
    },
    v47 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'purchase_price_unit',
      storageKey: null
    },
    v48 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'calculated_purchase_price',
      storageKey: null
    },
    v49 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'purchase_price_option',
      storageKey: null
    },
    v50 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'price3',
      storageKey: null
    },
    v51 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'simulated_price3',
      storageKey: null
    },
    v52 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'price4',
      storageKey: null
    },
    v53 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'price4_name',
      storageKey: null
    },
    v54 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'lot_area',
      storageKey: null
    },
    v55 = [
      v41 /*: any*/,
      v42 /*: any*/,
      v43 /*: any*/,
      v44 /*: any*/,
      v45 /*: any*/,
      v46 /*: any*/,
      v47 /*: any*/,
      v48 /*: any*/,
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'category_name',
        storageKey: null
      },
      v49 /*: any*/,
      v50 /*: any*/,
      v51 /*: any*/,
      v52 /*: any*/,
      v53 /*: any*/,
      v54 /*: any*/
    ],
    v56 = [v30 /*: any*/],
    v57 = [
      {
        alias: null,
        args: null,
        concreteType: 'Post',
        kind: 'LinkedField',
        name: 'items',
        plural: true,
        selections: [v22 /*: any*/, v21 /*: any*/, v25 /*: any*/],
        storageKey: null
      }
    ]
  return {
    fragment: {
      argumentDefinitions: [
        v0 /*: any*/,
        v1 /*: any*/,
        v2 /*: any*/,
        v3 /*: any*/,
        v4 /*: any*/,
        v5 /*: any*/,
        v6 /*: any*/
      ],
      kind: 'Fragment',
      metadata: null,
      name: 'postPage_indexQuery',
      selections: [
        {
          alias: 'post',
          args: v7 /*: any*/,
          concreteType: 'Post',
          kind: 'LinkedField',
          name: 'getPost',
          plural: false,
          selections: [
            {
              args: null,
              kind: 'FragmentSpread',
              name: 'Post_post'
            },
            {
              args: null,
              kind: 'FragmentSpread',
              name: 'PostList_post'
            },
            {
              args: null,
              kind: 'FragmentSpread',
              name: 'PostStructuredData_post'
            },
            {
              args: null,
              kind: 'FragmentSpread',
              name: 'PostSeoHead_post'
            },
            {
              args: null,
              kind: 'FragmentSpread',
              name: 'Breadcrumb_post'
            },
            {
              args: null,
              kind: 'FragmentSpread',
              name: 'RelatedPosts_post'
            },
            {
              args: null,
              kind: 'FragmentSpread',
              name: 'PostNoTitle_post'
            },
            {
              alias: null,
              args: v8 /*: any*/,
              concreteType: 'PostResult',
              kind: 'LinkedField',
              name: 'child_posts',
              plural: false,
              selections: [
                {
                  args: null,
                  kind: 'FragmentSpread',
                  name: 'PostList_posts'
                }
              ],
              storageKey: null
            },
            {
              alias: null,
              args: null,
              concreteType: 'Post',
              kind: 'LinkedField',
              name: 'parent_post',
              plural: false,
              selections: [v9 /*: any*/],
              storageKey: null
            },
            v10 /*: any*/,
            v11 /*: any*/,
            v12 /*: any*/
          ],
          storageKey: null
        },
        {
          alias: 'shortCodeCemeteries',
          args: v14 /*: any*/,
          concreteType: 'CemeteryResult',
          kind: 'LinkedField',
          name: 'listCemeteries',
          plural: false,
          selections: [
            {
              args: null,
              kind: 'FragmentSpread',
              name: 'ShortCodeContextProvider_cemeteryFragment'
            }
          ],
          storageKey: null
        },
        {
          alias: 'shortCodePosts',
          args: v15 /*: any*/,
          concreteType: 'PostResult',
          kind: 'LinkedField',
          name: 'listPosts',
          plural: false,
          selections: [
            {
              args: null,
              kind: 'FragmentSpread',
              name: 'ShortCodeContextProvider_postFragment'
            }
          ],
          storageKey: null
        },
        {
          alias: 'newlyPosts',
          args: v17 /*: any*/,
          concreteType: 'PostResult',
          kind: 'LinkedField',
          name: 'listPosts',
          plural: false,
          selections: v18 /*: any*/,
          storageKey:
            'listPosts(filter:{"template_name":"show_post"},page:{"from":0,"size":5})'
        },
        {
          alias: 'newlyCemeteryPosts',
          args: v19 /*: any*/,
          concreteType: 'PostResult',
          kind: 'LinkedField',
          name: 'listPosts',
          plural: false,
          selections: v18 /*: any*/,
          storageKey:
            'listPosts(filter:{"parent_slugs":["ohaka"]},page:{"from":0,"size":5})'
        },
        {
          alias: 'sameParentPosts',
          args: v20 /*: any*/,
          concreteType: 'PostResult',
          kind: 'LinkedField',
          name: 'listPosts',
          plural: false,
          selections: [
            {
              args: null,
              kind: 'FragmentSpread',
              name: 'SameParentPostList_Fragment'
            }
          ],
          storageKey: null
        }
      ],
      type: 'Query',
      abstractKey: null
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: [
        v6 /*: any*/,
        v0 /*: any*/,
        v4 /*: any*/,
        v2 /*: any*/,
        v5 /*: any*/,
        v3 /*: any*/,
        v1 /*: any*/
      ],
      kind: 'Operation',
      name: 'postPage_indexQuery',
      selections: [
        {
          alias: 'post',
          args: v7 /*: any*/,
          concreteType: 'Post',
          kind: 'LinkedField',
          name: 'getPost',
          plural: false,
          selections: [
            v21 /*: any*/,
            v22 /*: any*/,
            {
              alias: null,
              args: null,
              kind: 'ScalarField',
              name: 'content_text',
              storageKey: null
            },
            v10 /*: any*/,
            v25 /*: any*/,
            v26 /*: any*/,
            {
              alias: null,
              args: null,
              concreteType: 'PostShortCode',
              kind: 'LinkedField',
              name: 'shortcodes',
              plural: true,
              selections: [
                {
                  alias: null,
                  args: null,
                  kind: 'ScalarField',
                  name: 'index',
                  storageKey: null
                },
                {
                  alias: null,
                  args: null,
                  kind: 'ScalarField',
                  name: 'category',
                  storageKey: null
                },
                v27 /*: any*/,
                {
                  alias: null,
                  args: null,
                  concreteType: 'PostShortCodeParam',
                  kind: 'LinkedField',
                  name: 'params',
                  plural: true,
                  selections: [
                    {
                      alias: null,
                      args: null,
                      kind: 'ScalarField',
                      name: 'key',
                      storageKey: null
                    },
                    {
                      alias: null,
                      args: null,
                      kind: 'ScalarField',
                      name: 'value',
                      storageKey: null
                    }
                  ],
                  storageKey: null
                }
              ],
              storageKey: null
            },
            v28 /*: any*/,
            {
              alias: null,
              args: null,
              kind: 'ScalarField',
              name: 'published_at',
              storageKey: null
            },
            {
              alias: null,
              args: null,
              kind: 'ScalarField',
              name: 'meta_keywords',
              storageKey: null
            },
            {
              alias: null,
              args: null,
              kind: 'ScalarField',
              name: 'meta_robots',
              storageKey: null
            },
            {
              alias: null,
              args: null,
              concreteType: 'Post',
              kind: 'LinkedField',
              name: 'parent_post',
              plural: false,
              selections: [
                v21 /*: any*/,
                v22 /*: any*/,
                v9 /*: any*/,
                {
                  alias: null,
                  args: null,
                  concreteType: 'Post',
                  kind: 'LinkedField',
                  name: 'parent_post',
                  plural: false,
                  selections: [
                    v21 /*: any*/,
                    v22 /*: any*/,
                    v9 /*: any*/,
                    {
                      alias: null,
                      args: null,
                      concreteType: 'Post',
                      kind: 'LinkedField',
                      name: 'parent_post',
                      plural: false,
                      selections: [v21 /*: any*/, v22 /*: any*/, v9 /*: any*/],
                      storageKey: null
                    }
                  ],
                  storageKey: null
                }
              ],
              storageKey: null
            },
            {
              alias: null,
              args: null,
              concreteType: 'Cemetery',
              kind: 'LinkedField',
              name: 'holder_cemetery',
              plural: false,
              selections: [
                v29 /*: any*/,
                v30 /*: any*/,
                {
                  alias: null,
                  args: null,
                  concreteType: 'Station',
                  kind: 'LinkedField',
                  name: 'nearest_station_node',
                  plural: false,
                  selections: [
                    {
                      alias: 'stationId',
                      args: null,
                      kind: 'ScalarField',
                      name: 'id',
                      storageKey: null
                    },
                    v30 /*: any*/,
                    {
                      alias: null,
                      args: null,
                      concreteType: 'City',
                      kind: 'LinkedField',
                      name: 'city',
                      plural: false,
                      selections: v34 /*: any*/,
                      storageKey: null
                    }
                  ],
                  storageKey: null
                },
                {
                  alias: null,
                  args: null,
                  concreteType: 'City',
                  kind: 'LinkedField',
                  name: 'city_node',
                  plural: false,
                  selections: v34 /*: any*/,
                  storageKey: null
                },
                {
                  alias: null,
                  args: null,
                  concreteType: 'CemeteryPrefecture',
                  kind: 'LinkedField',
                  name: 'prefecture',
                  plural: false,
                  selections: [v35 /*: any*/, v30 /*: any*/],
                  storageKey: null
                }
              ],
              storageKey: null
            },
            {
              alias: null,
              args: null,
              concreteType: 'City',
              kind: 'LinkedField',
              name: 'holder_city',
              plural: false,
              selections: [
                v31 /*: any*/,
                v30 /*: any*/,
                v32 /*: any*/,
                {
                  alias: null,
                  args: null,
                  kind: 'ScalarField',
                  name: 'prefectureName',
                  storageKey: null
                },
                {
                  alias: null,
                  args: null,
                  kind: 'ScalarField',
                  name: 'prefectureRoma',
                  storageKey: null
                }
              ],
              storageKey: null
            },
            {
              alias: null,
              args: null,
              concreteType: 'HolderPrefecture',
              kind: 'LinkedField',
              name: 'holder_prefecture',
              plural: false,
              selections: [v30 /*: any*/, v35 /*: any*/],
              storageKey: null
            },
            {
              alias: null,
              args: [
                {
                  kind: 'Literal',
                  name: 'page',
                  value: {
                    from: 0,
                    size: 20
                  }
                }
              ],
              concreteType: 'PostResult',
              kind: 'LinkedField',
              name: 'related_posts',
              plural: false,
              selections: [
                {
                  alias: null,
                  args: null,
                  concreteType: 'Post',
                  kind: 'LinkedField',
                  name: 'items',
                  plural: true,
                  selections: [v21 /*: any*/, v25 /*: any*/, v22 /*: any*/],
                  storageKey: null
                }
              ],
              storageKey: 'related_posts(page:{"from":0,"size":20})'
            },
            {
              alias: null,
              args: v8 /*: any*/,
              concreteType: 'PostResult',
              kind: 'LinkedField',
              name: 'child_posts',
              plural: false,
              selections: [
                {
                  alias: null,
                  args: null,
                  concreteType: 'PaginationStatus',
                  kind: 'LinkedField',
                  name: 'pagination',
                  plural: false,
                  selections: [
                    {
                      alias: null,
                      args: null,
                      kind: 'ScalarField',
                      name: 'currentPageNumber',
                      storageKey: null
                    },
                    {
                      alias: null,
                      args: null,
                      kind: 'ScalarField',
                      name: 'lastPageNumber',
                      storageKey: null
                    }
                  ],
                  storageKey: null
                },
                {
                  alias: null,
                  args: null,
                  concreteType: 'Post',
                  kind: 'LinkedField',
                  name: 'items',
                  plural: true,
                  selections: [
                    v21 /*: any*/,
                    v22 /*: any*/,
                    v37 /*: any*/,
                    v26 /*: any*/
                  ],
                  storageKey: null
                }
              ],
              storageKey: null
            },
            v11 /*: any*/,
            v12 /*: any*/
          ],
          storageKey: null
        },
        {
          alias: 'shortCodeCemeteries',
          args: v14 /*: any*/,
          concreteType: 'CemeteryResult',
          kind: 'LinkedField',
          name: 'listCemeteries',
          plural: false,
          selections: [
            {
              alias: null,
              args: null,
              concreteType: 'Cemetery',
              kind: 'LinkedField',
              name: 'items',
              plural: true,
              selections: [
                v29 /*: any*/,
                v30 /*: any*/,
                {
                  alias: null,
                  args: null,
                  kind: 'ScalarField',
                  name: 'address',
                  storageKey: null
                },
                {
                  alias: null,
                  args: null,
                  concreteType: 'CemeteryAccesses',
                  kind: 'LinkedField',
                  name: 'accesses',
                  plural: false,
                  selections: [
                    {
                      alias: null,
                      args: null,
                      kind: 'ScalarField',
                      name: 'car',
                      storageKey: null
                    },
                    {
                      alias: null,
                      args: null,
                      kind: 'ScalarField',
                      name: 'other',
                      storageKey: null
                    },
                    {
                      alias: null,
                      args: null,
                      kind: 'ScalarField',
                      name: 'shuttle_bus',
                      storageKey: null
                    },
                    {
                      alias: null,
                      args: null,
                      kind: 'ScalarField',
                      name: 'taxi',
                      storageKey: null
                    }
                  ],
                  storageKey: null
                },
                {
                  alias: null,
                  args: null,
                  concreteType: 'CemeteryNearestStation',
                  kind: 'LinkedField',
                  name: 'nearest_station',
                  plural: false,
                  selections: [
                    v30 /*: any*/,
                    {
                      alias: null,
                      args: null,
                      kind: 'ScalarField',
                      name: 'distance',
                      storageKey: null
                    }
                  ],
                  storageKey: null
                },
                {
                  alias: null,
                  args: null,
                  concreteType: 'CemeteryChoice',
                  kind: 'LinkedField',
                  name: 'cemetery_types',
                  plural: true,
                  selections: v38 /*: any*/,
                  storageKey: null
                },
                {
                  alias: null,
                  args: null,
                  concreteType: 'CemeteryChoice',
                  kind: 'LinkedField',
                  name: 'sects',
                  plural: true,
                  selections: v38 /*: any*/,
                  storageKey: null
                },
                {
                  alias: null,
                  args: null,
                  concreteType: 'CemeteryChoice',
                  kind: 'LinkedField',
                  name: 'section_types',
                  plural: true,
                  selections: v38 /*: any*/,
                  storageKey: null
                },
                {
                  alias: null,
                  args: null,
                  concreteType: 'CemeteryReviewSummary',
                  kind: 'LinkedField',
                  name: 'review_summary',
                  plural: false,
                  selections: [
                    {
                      alias: null,
                      args: null,
                      kind: 'ScalarField',
                      name: 'total_score',
                      storageKey: null
                    },
                    v33 /*: any*/,
                    {
                      alias: null,
                      args: null,
                      concreteType: 'CemeteryReview',
                      kind: 'LinkedField',
                      name: 'valuable_review',
                      plural: false,
                      selections: [
                        {
                          alias: null,
                          args: null,
                          kind: 'ScalarField',
                          name: 'age',
                          storageKey: null
                        },
                        {
                          alias: null,
                          args: null,
                          concreteType: 'CemeteryReviewAnswer',
                          kind: 'LinkedField',
                          name: 'answers',
                          plural: true,
                          selections: [
                            {
                              alias: null,
                              args: null,
                              kind: 'ScalarField',
                              name: 'text',
                              storageKey: null
                            },
                            v27 /*: any*/
                          ],
                          storageKey: null
                        },
                        {
                          alias: null,
                          args: null,
                          kind: 'ScalarField',
                          name: 'gender',
                          storageKey: null
                        }
                      ],
                      storageKey: null
                    }
                  ],
                  storageKey: null
                },
                {
                  alias: null,
                  args: null,
                  concreteType: 'CemeteryImage',
                  kind: 'LinkedField',
                  name: 'main_image',
                  plural: false,
                  selections: [
                    v24 /*: any*/,
                    {
                      alias: null,
                      args: null,
                      kind: 'ScalarField',
                      name: 'active',
                      storageKey: null
                    },
                    v39 /*: any*/
                  ],
                  storageKey: null
                },
                {
                  alias: null,
                  args: null,
                  kind: 'ScalarField',
                  name: 'director_comment',
                  storageKey: null
                },
                {
                  alias: null,
                  args: null,
                  concreteType: 'CemeteryDescription',
                  kind: 'LinkedField',
                  name: 'descriptions',
                  plural: true,
                  selections: [
                    {
                      alias: null,
                      args: null,
                      kind: 'ScalarField',
                      name: 'subject',
                      storageKey: null
                    }
                  ],
                  storageKey: null
                },
                {
                  alias: null,
                  args: null,
                  concreteType: 'CemeteryChoice',
                  kind: 'LinkedField',
                  name: 'features',
                  plural: true,
                  selections: v40 /*: any*/,
                  storageKey: null
                },
                {
                  alias: null,
                  args: null,
                  concreteType: 'CemeteryChoice',
                  kind: 'LinkedField',
                  name: 'facilities',
                  plural: true,
                  selections: v40 /*: any*/,
                  storageKey: null
                },
                {
                  alias: null,
                  args: null,
                  kind: 'ScalarField',
                  name: 'kana',
                  storageKey: null
                },
                {
                  alias: null,
                  args: null,
                  concreteType: 'CemeteryImage',
                  kind: 'LinkedField',
                  name: 'sub_images',
                  plural: true,
                  selections: [v39 /*: any*/, v24 /*: any*/],
                  storageKey: null
                },
                {
                  alias: null,
                  args: null,
                  concreteType: 'CemeteryBestPriceByCategory',
                  kind: 'LinkedField',
                  name: 'best_price_by_category',
                  plural: false,
                  selections: [
                    {
                      alias: null,
                      args: null,
                      concreteType: 'CemeteryPriceAndSpec',
                      kind: 'LinkedField',
                      name: 'normal',
                      plural: false,
                      selections: v55 /*: any*/,
                      storageKey: null
                    },
                    {
                      alias: null,
                      args: null,
                      concreteType: 'CemeteryPriceAndSpec',
                      kind: 'LinkedField',
                      name: 'nokotsu',
                      plural: false,
                      selections: v55 /*: any*/,
                      storageKey: null
                    },
                    {
                      alias: null,
                      args: null,
                      concreteType: 'CemeteryPriceAndSpec',
                      kind: 'LinkedField',
                      name: 'jumoku',
                      plural: false,
                      selections: v55 /*: any*/,
                      storageKey: null
                    },
                    {
                      alias: null,
                      args: null,
                      concreteType: 'CemeteryPriceAndSpec',
                      kind: 'LinkedField',
                      name: 'eitai_kuyo',
                      plural: false,
                      selections: v55 /*: any*/,
                      storageKey: null
                    }
                  ],
                  storageKey: null
                },
                {
                  alias: null,
                  args: null,
                  concreteType: 'CemeteryPrefecture',
                  kind: 'LinkedField',
                  name: 'prefecture',
                  plural: false,
                  selections: v56 /*: any*/,
                  storageKey: null
                },
                {
                  alias: null,
                  args: null,
                  concreteType: 'CemeteryCity',
                  kind: 'LinkedField',
                  name: 'city',
                  plural: false,
                  selections: v56 /*: any*/,
                  storageKey: null
                },
                {
                  alias: null,
                  args: null,
                  kind: 'ScalarField',
                  name: 'requestable',
                  storageKey: null
                },
                {
                  alias: null,
                  args: null,
                  concreteType: 'CemeteryPriceAndSpec',
                  kind: 'LinkedField',
                  name: 'price_and_specs',
                  plural: true,
                  selections: [
                    {
                      alias: 'priceId',
                      args: null,
                      kind: 'ScalarField',
                      name: 'id',
                      storageKey: null
                    },
                    v30 /*: any*/,
                    v41 /*: any*/,
                    v42 /*: any*/,
                    v43 /*: any*/,
                    v44 /*: any*/,
                    v45 /*: any*/,
                    v46 /*: any*/,
                    v47 /*: any*/,
                    v48 /*: any*/,
                    v52 /*: any*/,
                    v53 /*: any*/,
                    {
                      alias: null,
                      args: null,
                      kind: 'ScalarField',
                      name: 'price4_unit',
                      storageKey: null
                    },
                    v49 /*: any*/,
                    v50 /*: any*/,
                    {
                      alias: null,
                      args: null,
                      kind: 'ScalarField',
                      name: 'price3_unit',
                      storageKey: null
                    },
                    v51 /*: any*/,
                    v54 /*: any*/,
                    {
                      alias: null,
                      args: null,
                      kind: 'ScalarField',
                      name: 'lot_area_spec',
                      storageKey: null
                    },
                    {
                      alias: null,
                      args: null,
                      kind: 'ScalarField',
                      name: 'capacity',
                      storageKey: null
                    },
                    {
                      alias: null,
                      args: null,
                      kind: 'ScalarField',
                      name: 'spec',
                      storageKey: null
                    },
                    {
                      alias: null,
                      args: null,
                      concreteType: 'CemeteryPriceAndSpecImage',
                      kind: 'LinkedField',
                      name: 'image',
                      plural: false,
                      selections: v36 /*: any*/,
                      storageKey: null
                    }
                  ],
                  storageKey: null
                }
              ],
              storageKey: null
            }
          ],
          storageKey: null
        },
        {
          alias: 'shortCodePosts',
          args: v15 /*: any*/,
          concreteType: 'PostResult',
          kind: 'LinkedField',
          name: 'listPosts',
          plural: false,
          selections: [
            {
              alias: null,
              args: null,
              concreteType: 'Post',
              kind: 'LinkedField',
              name: 'items',
              plural: true,
              selections: [
                v21 /*: any*/,
                v37 /*: any*/,
                v22 /*: any*/,
                v28 /*: any*/
              ],
              storageKey: null
            }
          ],
          storageKey: null
        },
        {
          alias: 'newlyPosts',
          args: v17 /*: any*/,
          concreteType: 'PostResult',
          kind: 'LinkedField',
          name: 'listPosts',
          plural: false,
          selections: v57 /*: any*/,
          storageKey:
            'listPosts(filter:{"template_name":"show_post"},page:{"from":0,"size":5})'
        },
        {
          alias: 'newlyCemeteryPosts',
          args: v19 /*: any*/,
          concreteType: 'PostResult',
          kind: 'LinkedField',
          name: 'listPosts',
          plural: false,
          selections: v57 /*: any*/,
          storageKey:
            'listPosts(filter:{"parent_slugs":["ohaka"]},page:{"from":0,"size":5})'
        },
        {
          alias: 'sameParentPosts',
          args: v20 /*: any*/,
          concreteType: 'PostResult',
          kind: 'LinkedField',
          name: 'listPosts',
          plural: false,
          selections: v57 /*: any*/,
          storageKey: null
        }
      ]
    },
    params: {
      cacheID: 'b34d362cdd410d31ec1331ecf63d8549',
      id: null,
      metadata: {},
      name: 'postPage_indexQuery',
      operationKind: 'query',
      text: 'query postPage_indexQuery(\n  $slug: String!\n  $page: PaginationInput!\n  $shortCodeCemeteryIds: [Int!]!\n  $requestShortCodeCemeteryIdSize: Int!\n  $shortCodeSlugs: [String!]!\n  $requestShortCodeSlugSize: Int!\n  $parentSlug: [String]\n) {\n  post: getPost(slug: $slug) {\n    ...Post_post\n    ...PostList_post\n    ...PostStructuredData_post\n    ...PostSeoHead_post\n    ...Breadcrumb_post\n    ...RelatedPosts_post\n    ...PostNoTitle_post\n    child_posts(page: $page) {\n      ...PostList_posts\n    }\n    parent_post {\n      short_title\n    }\n    template_name\n    status\n    redirect_to\n  }\n  shortCodeCemeteries: listCemeteries(filter: {ids: $shortCodeCemeteryIds}, page: {from: 0, size: $requestShortCodeCemeteryIdSize}) {\n    ...ShortCodeContextProvider_cemeteryFragment\n  }\n  shortCodePosts: listPosts(filter: {slugs: $shortCodeSlugs}, page: {from: 0, size: $requestShortCodeSlugSize}) {\n    ...ShortCodeContextProvider_postFragment\n  }\n  newlyPosts: listPosts(filter: {template_name: "show_post"}, page: {from: 0, size: 5}) {\n    ...PostListCard_posts\n  }\n  newlyCemeteryPosts: listPosts(filter: {parent_slugs: ["ohaka"]}, page: {from: 0, size: 5}) {\n    ...PostListCard_posts\n  }\n  sameParentPosts: listPosts(filter: {parent_slugs: $parentSlug}, page: {size: 8}) {\n    ...SameParentPostList_Fragment\n  }\n}\n\nfragment BreadcrumbForHolderCemetery_post on Post {\n  slug\n  h1\n  holder_cemetery {\n    cemeteryId: id\n    name\n    nearest_station_node {\n      stationId: id\n      name\n      city {\n        cityId: id\n        name\n        designatedCity {\n          designatedCityId: id\n          name\n        }\n        cemeteryCount {\n          count\n        }\n      }\n    }\n    city_node {\n      cityId: id\n      name\n      designatedCity {\n        designatedCityId: id\n        name\n      }\n      cemeteryCount {\n        count\n      }\n    }\n    prefecture {\n      roma\n      name\n    }\n  }\n}\n\nfragment BreadcrumbForHolderCity_post on Post {\n  slug\n  h1\n  holder_city {\n    cityId: id\n    name\n    designatedCity {\n      designatedCityId: id\n      name\n    }\n    prefectureName\n    prefectureRoma\n  }\n}\n\nfragment BreadcrumbForHolderPrefecture_post on Post {\n  slug\n  h1\n  holder_prefecture {\n    name\n    roma\n  }\n}\n\nfragment BreadcrumbForPost_post on Post {\n  slug\n  h1\n  parent_post {\n    slug\n    h1\n    short_title\n    parent_post {\n      slug\n      h1\n      short_title\n      parent_post {\n        slug\n        h1\n        short_title\n      }\n    }\n  }\n}\n\nfragment Breadcrumb_post on Post {\n  ...BreadcrumbForPost_post\n  ...BreadcrumbForHolderCemetery_post\n  holder_cemetery {\n    name\n  }\n  ...BreadcrumbForHolderCity_post\n  holder_city {\n    name\n  }\n  ...BreadcrumbForHolderPrefecture_post\n  holder_prefecture {\n    name\n  }\n}\n\nfragment PostListCard_posts on PostResult {\n  items {\n    h1\n    slug\n    image {\n      url\n      alt\n    }\n  }\n}\n\nfragment PostList_post on Post {\n  slug\n  h1\n}\n\nfragment PostList_posts on PostResult {\n  pagination {\n    currentPageNumber\n    lastPageNumber\n  }\n  items {\n    slug\n    h1\n    image {\n      alt\n      url\n    }\n    modified_at\n  }\n}\n\nfragment PostNoTitle_post on Post {\n  h1\n  content_text\n  template_name\n  image {\n    url\n    alt\n  }\n  shortcodes {\n    index\n    category\n    code\n    params {\n      key\n      value\n    }\n  }\n}\n\nfragment PostSeoHead_post on Post {\n  h1\n  slug\n  image {\n    url\n  }\n  meta_description\n  meta_keywords\n  meta_robots\n}\n\nfragment PostStructuredData_post on Post {\n  slug\n  h1\n  image {\n    url\n  }\n  meta_description\n  published_at\n  modified_at\n}\n\nfragment Post_post on Post {\n  slug\n  h1\n  content_text\n  template_name\n  image {\n    url\n    alt\n  }\n  modified_at\n  shortcodes {\n    index\n    category\n    code\n    params {\n      key\n      value\n    }\n  }\n}\n\nfragment RelatedPosts_post on Post {\n  related_posts(page: {from: 0, size: 20}) {\n    items {\n      slug\n      image {\n        url\n        alt\n      }\n      h1\n    }\n  }\n}\n\nfragment SameParentPostList_Fragment on PostResult {\n  items {\n    h1\n    slug\n    image {\n      url\n      alt\n    }\n  }\n}\n\nfragment ShortCodeContextProvider_cemeteryFragment on CemeteryResult {\n  items {\n    cemeteryId: id\n    name\n    address\n    accesses {\n      car\n      other\n      shuttle_bus\n      taxi\n    }\n    nearest_station {\n      name\n      distance\n    }\n    cemetery_types {\n      name\n      code\n    }\n    sects {\n      name\n      code\n    }\n    section_types {\n      name\n      code\n    }\n    review_summary {\n      total_score\n      count\n      valuable_review {\n        age\n        answers {\n          text\n          code\n        }\n        gender\n      }\n    }\n    main_image {\n      alt\n      active\n      path\n    }\n    director_comment\n    descriptions {\n      subject\n    }\n    features {\n      code\n      name\n    }\n    facilities {\n      code\n      name\n    }\n    kana\n    sub_images {\n      path\n      alt\n    }\n    best_price_by_category {\n      normal {\n        category_code\n        price1\n        price1_unit\n        price2\n        price2_unit\n        purchase_price\n        purchase_price_unit\n        calculated_purchase_price\n        category_name\n        purchase_price_option\n        price3\n        simulated_price3\n        price4\n        price4_name\n        lot_area\n      }\n      nokotsu {\n        category_code\n        price1\n        price1_unit\n        price2\n        price2_unit\n        purchase_price\n        purchase_price_unit\n        calculated_purchase_price\n        category_name\n        purchase_price_option\n        price3\n        simulated_price3\n        price4\n        price4_name\n        lot_area\n      }\n      jumoku {\n        category_code\n        price1\n        price1_unit\n        price2\n        price2_unit\n        purchase_price\n        purchase_price_unit\n        calculated_purchase_price\n        category_name\n        purchase_price_option\n        price3\n        simulated_price3\n        price4\n        price4_name\n        lot_area\n      }\n      eitai_kuyo {\n        category_code\n        price1\n        price1_unit\n        price2\n        price2_unit\n        purchase_price\n        purchase_price_unit\n        calculated_purchase_price\n        category_name\n        purchase_price_option\n        price3\n        simulated_price3\n        price4\n        price4_name\n        lot_area\n      }\n    }\n    prefecture {\n      name\n    }\n    city {\n      name\n    }\n    requestable\n    price_and_specs {\n      priceId: id\n      name\n      category_code\n      price1\n      price1_unit\n      price2\n      price2_unit\n      purchase_price\n      purchase_price_unit\n      calculated_purchase_price\n      price4\n      price4_name\n      price4_unit\n      purchase_price_option\n      price3\n      price3_unit\n      simulated_price3\n      lot_area\n      lot_area_spec\n      capacity\n      spec\n      image {\n        alt\n        url\n      }\n    }\n  }\n}\n\nfragment ShortCodeContextProvider_postFragment on PostResult {\n  items {\n    slug\n    image {\n      alt\n      url\n    }\n    h1\n    meta_description\n  }\n}\n'
    }
  }
})()

;(node as any).hash = 'a013fa91c29b226bdab8d6856eff745c'

export default node
